module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "title": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy_txt_ts"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("ZONDERVAN")])]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_c('i', [_vm._v("If You Want to Walk on Water, You’ve Got to Get Out of the Boat")])]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt"
  }, [_vm._v("Copyright © 2001 by John Ortberg")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Requests for information should be addressed to:")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Zondervan, "), _c('i', [_vm._v("3900 Sparks Dr. SE, Grand Rapids, Michigan 49546")])]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("This edition: ISBN 978-0-310-34046-1 (softcover)")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("ISBN 978-0-310-26064-6 (audio)")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1t"
  }, [_vm._v("ISBN 978-0-310-29606-5 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Epub Edition January 2021 9780310296065")]), _vm._v(" "), _c('div', {
    staticClass: "hr3"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Ortberg, John.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txti"
  }, [_vm._v("If you want to walk on water, you’ve got to get out of the boat / John Ortberg.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txtii"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txti"
  }, [_vm._v("Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txti"
  }, [_vm._v("ISBN 978-0-310-22863-9 (hardcover)")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txti"
  }, [_vm._v("1. Trust in God—Christianity. 2. Bible N.T. Matthew XIV, 22–33—Criticism, interpretation, etc. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_2"
  }, [_vm._v("BV4637 .O78 2000")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copy_txt_hang_1"
  }, [_vm._v("248.4—dc21")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy_txt_hang_2"
  }, [_vm._v("00-047714")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hr4"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from the New Revised Standard Version Bible. Copyright © 1989, Division of Christian Education of the National Council of the Churches of Christ in the United States of America. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Citations in "), _c('span', {
    attrs: {
      "href": "#/text/9780310296065_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7")]), _vm._v(" from Parker Palmer, "), _c('i', [_vm._v("Let Your Life Speak")]), _vm._v(", copyright © 2000 by Parker Palmer, are reprinted by permission of Jossey-Bass, Inc., a subsidary of John Wiley & Sons, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("Any internet addresses (websites, blogs, etc.) and telephone numbers in this book are offered as a resource. They are not intended in any way to be or imply an endorsement by Zondervan, nor does Zondervan vouch for the content of these sites and numbers for the life of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_c('i', [_vm._v("Interior design: Melissa Elenbaas")])]), _vm._v(" "), _c('p', {
    staticClass: "copy_txt_1"
  }, [_vm._v("First printing May 2014 / Printed in the United States of America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f2a998","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310296065_Copyright.vue
// module id = 69
// module chunks = 0